/**
 * Section & Field Spacing Configuration
 * All values are MUI spacing units (multipliers of 8px)
 */

// ============================================
// SECTION SPACING (Accordion sections)
// ============================================
export const SECTION_MARGIN_BOTTOM = 2; // 16px - между секциями
export const SECTION_PADDING = 2; // 16px - внутренний padding
export const SECTION_BORDER_RADIUS = 1; // 8px - скругление

// ============================================
// FIELD SPACING (TextElement, inputs)
// ============================================
export const FIELD_MARGIN_BOTTOM = 2; // 16px - между полями
export const FIELD_GAP = 1; // 8px - gap в row layout
export const FIELD_GAP_SMALL = 0.5; // 4px - мелкий gap

// Style panel grid
export const FIELD_STYLE_GRID_GAP = 1; // 8px - gap в 2-column grid
export const FIELD_STYLE_MARGIN_TOP = 1; // 8px - отступ сверху panel
export const FIELD_STYLE_PADDING_LEFT = 2; // 16px - отступ слева для style panel

// ============================================
// SEMANTIC SPACING SCALE (общие отступы)
// ============================================
export const SPACING = {
  xs: 0.5, // 4px
  sm: 1, // 8px
  md: 2, // 16px
  lg: 3, // 24px
  xl: 4, // 32px
} as const;
